import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import useTitle from "../components/Title";

const Support = () => {
  useTitle("- Support");
  const [submitted, setSubmitted] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const form = e.target;
    const formData = new FormData(form);
    
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
    .then(() => {
      setSubmitted(true);
      form.reset();
      setTimeout(() => setSubmitted(false), 5000);
    })
    .catch((error) => {
      console.error("Error:", error);
      alert("There was an error submitting the form. Please try again.");
    });
  };

  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">
          {/* <LoginForm /> */}

          <div className="row justify-content between align-items-center"> 
            <div className="col-md-8 col-sm-12">
              <h1 className="mt-5 event-heading-start">Support.</h1>
              <p className="event-sub-text mb-3"> If you have any problems or questions, feel free to reach out to us.  </p>
            </div>

          {user && (
           <div className="col-md-4 col-sm-12 text-md-end text-sm-start">
               <Link className="btn btn-sm btn-primary" to="/Settings">  Get Support </Link>
             </div>
           )}


           </div>

       

            <div className="filter-section mb-5"></div>

            <div className="row mb-5">

                <div className="col-md-6 col-sm-12 mx-auto mb-3">
                    <h4>Get in touch with us: </h4>
                    <p className="mb-3 text-gray-500">You can email us directly at <span className="text-primary"> support@attendiau.co.uk  </span> or use the contact form below to send us your message. Whether you have a question, need assistance, or just want to share feedback, we’re happy to hear from you.
    <br></br>  <br></br>
Our team reviews every message and will do our best to respond as quickly as possible. We appreciate your patience during busy periods and promise to get back to you as soon as we can.
  <br></br>  <br></br>
Thank you for reaching out, we look forward to helping you! </p>

    

                </div>

                 <div className="col-md-6 col-sm-12 mx-auto mb-3">
                    <div className="card p-4">
                      {submitted && (
                        <div className="alert alert-success" role="alert">
                          <i className="bi bi-check-circle me-2"></i>
                          Thank you! Your message has been sent successfully. We'll get back to you soon.
                        </div>
                      )}
                      <form name="contact" method="POST" onSubmit={handleSubmit} netlify>
                            <input type="hidden" name="form-name" value="contact" />

                            <div className="row">
                                <div className="col-12 mb-3">
                                <label className="form-label">Name</label>
                                <input 
                                  type="text" 
                                  name="name" 
                                  className="form-control" 
                                  required 
                                />
                                </div>

                                <div className="col-12 mb-3">
                                <label className="form-label">Email</label>
                                <input 
                                  type="email" 
                                  name="email" 
                                  className="form-control" 
                                  required 
                                />
                                </div>

                                <div className="col-12 mb-3">
                                <label className="form-label">Title</label>
                                <input 
                                  type="text" 
                                  name="title" 
                                  className="form-control" 
                                />
                                </div>

                                <div className="col-12 mb-3">
                                <label className="form-label">Description</label>
                                <textarea 
                                  name="message" 
                                  className="form-control"
                                ></textarea>
                                </div>

                                <div className="col-12 text-end">
                                <button 
                                  type="submit" 
                                  className="btn btn-primary"
                                >
                                    Send
                                </button>
                                </div>
                            </div>
                            </form>
                          
                    </div>
                       <p className="small mt-3"> expect to wait 2-3 business days for a response.</p> 
                </div>



            </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Support;
